import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

const createBaseQuery = (baseUrl) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('access_token');
      if (token) {
        headers.set('Authorization', `JWT ${token}`);
      }
      return headers;
    },
  });

const baseQuery = createBaseQuery(
  `${process.env.REACT_APP_BACKEND_URL}health`,
);

export const offersApi = createApi({
  reducerPath: 'offersApi',
  baseQuery: baseQuery,
  tagTypes: ['Covers'],
  endpoints: (builder) => ({
    getAvailableCovers: builder.query({
      query: (id) => `getAvailableCovers/${id}/`,
      providesTags: [{ type: 'Covers' }],
    }),
  }),
});

export const { useGetAvailableCoversQuery } = offersApi;
